import { useScopedAtomValue } from '@lemon8/web-app-shared/ssr';
import { FC, PropsWithChildren } from 'react';
import { StepScrollUI } from '~/components/step-scroll-ui';
import { $NestedSwiperSlideInfo, $SlideToNestedIndex } from '../../atoms';

export const SwiperAction: FC<PropsWithChildren> = (props) => {
  const { children } = props;
  const nestedSwiperSlideInfo = useScopedAtomValue($NestedSwiperSlideInfo);
  const slideToNestedIndex = useScopedAtomValue($SlideToNestedIndex);

  const left = nestedSwiperSlideInfo.current > 0;
  const right = nestedSwiperSlideInfo.current < nestedSwiperSlideInfo.length - 1;

  const handleClickLeft = (): void => slideToNestedIndex(nestedSwiperSlideInfo.current - 1);
  const handleClickRight = (): void => slideToNestedIndex(nestedSwiperSlideInfo.current + 1);

  return (
    <StepScrollUI left={left} right={right} onClickLeft={handleClickLeft} onClickRight={handleClickRight}>
      {children}
    </StepScrollUI>
  );
};
